import { render } from "./AgentAddUpdateModal.vue?vue&type=template&id=8e6c0f4a"
import script from "./AgentAddUpdateModal.vue?vue&type=script&lang=js"
export * from "./AgentAddUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__